'use client';
import { ChevronRight } from 'lucide-react';
import { ReactNode, useState } from 'react';

const CollapsibleSection = ({
  header,
  children,
  defaultOpen = true,
}: {
  header: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div>
      <div className="text-primary font-medium py-4 border-y flex items-center gap-1">
        {header}
        <ChevronRight
          size="16"
          className={`cursor-pointer transition-transform duration-300 ${
            isOpen ? 'rotate-90' : ''
          }`}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      {isOpen && children}
    </div>
  );
};

export default CollapsibleSection;
